import Grid from "@mui/material/Grid2";
import { useMemo } from "react";
import { Stack, Typography } from "@mui/material";
import { Markdown } from "@/app/features/shared/markdown/Markdown";
import { RelatedInfo } from "@/app/lib/generated/graphql-types";
import dynamic from "next/dynamic";
import { RELATED_INFOS_SPACING } from "@/app/features/shared/related-infos/ui/spacing";
import Section from "@/app/features/shared/snap-section/Section";

const LinksView = dynamic(() => import("./LinksView"))
const ContactView = dynamic(() => import("./ContactView"))

export default function RelatedInfoViewExtensive({ info }: { info: RelatedInfo }) {

    const {
        showGeneralContact,
        teamMember,
        links,
        subtitle,
        title,
        description
    } = info;
    
    const showRightSide = useMemo(() => {
        return showGeneralContact
            || !!teamMember
            || (links && links.length > 0);
    }, [showGeneralContact, teamMember, links]);

    if (showRightSide) {
        return (
            <Grid
                className="related-info-extensive-view-root"
                container
                spacing={RELATED_INFOS_SPACING.layout}
                // sx={{
                //     px: { xs: '5%', md: '10%' }
                // }}
            >
                <Grid size={{ xs: 12, md: 9 }}>
                    <Stack spacing={RELATED_INFOS_SPACING.content}>
                        <Stack spacing={RELATED_INFOS_SPACING.text}>
                            {subtitle && (
                                <Typography variant="h5" color="text.secondary">{subtitle}</Typography>
                            )}
                            <Typography variant="h2" color="primary">{title}</Typography>
                        </Stack>
                        {description && (
                            <Markdown value={description} />
                        )}
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <Stack spacing={RELATED_INFOS_SPACING.sidebar}>
                        <ContactView info={info}/>
                        <LinksView info={info} />
                    </Stack>
                </Grid>
            </Grid>
        );
    }

    return (
        <Section contentHeight='fit-content'>
            <Grid
                className="related-info-extensive-view-root"
                container
                spacing={RELATED_INFOS_SPACING.layout}
            >
                <Grid size={3}></Grid>
                <h1>Extensive View Variant</h1>
                <p>This is the extensive view variant of the component.</p>
            </Grid>
        </Section>
    );
}
